module.exports = __webpack_public_path__ + "static/light.80ec4029.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Light/light.png
// module id = 203
// module chunks = 213534597649335 241203398517478